;
define("product_list_display_full.tpl", function(){});

